// Shopify 视频加载优化核心逻辑
document.addEventListener('DOMContentLoaded', function() {
  const videoCards = document.querySelectorAll('.video-card-shopify');
  const modal = document.getElementById('shopifyVideoModal');
  const modalVideo = document.getElementById('modalVideoPlayer');
  const closeBtn = document.getElementById('modalCloseBtn');
  
  // 1. 点击卡片加载并播放视频（按需加载，不提前请求）
  videoCards.forEach(card => {
    card.addEventListener('click', function() {
      const videoUrl = this.getAttribute('data-video-url');
      
      // 清空原有视频，避免缓存
      modalVideo.src = '';
      // 设置新视频地址（仅此时开始加载）
      modalVideo.src = videoUrl;
      
      // 显示弹窗
      modal.classList.add('active');
      
      // 尝试自动播放（兼容Shopify移动端）
      modalVideo.play().catch(err => {
        console.log('需要手动点击播放:', err);
        // 移动端兼容：显示播放控件
        modalVideo.controls = true;
      });
    });
  });
  
  // 2. 关闭弹窗 - 立即释放视频资源
  function closeModal() {
    modal.classList.remove('active');
    modalVideo.pause();
    // 彻底清空视频源，停止加载
    modalVideo.src = '';
    modalVideo.load();
  }
  
  closeBtn.addEventListener('click', closeModal);
  
  // 点击弹窗背景关闭
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });
  
  // ESC键关闭
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
  
  // 3. 优化滚动逻辑：移除清空图片src的错误代码，保留性能优化思路（可选）
  // 原逻辑会导致图片加载中断，此处注释掉，如需性能优化可改用IntersectionObserver
  // window.addEventListener('scroll', function() {
  //   if (modal.classList.contains('active')) return;
  //   // 推荐替代方案：使用IntersectionObserver监听元素可见性，而非滚动事件
  // });
});